<script lang="ts" setup>
import { ref } from 'vue';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { useEventListener } from '@vueuse/core';
import OmniSearchBar from '../OmniSearch/OmniSearchBar.vue';

const omnisearch = ref<InstanceType<typeof OmniSearchBar>>();

useEventListener(window, 'message', async (event) => {
  const { type } = event.data;
  if (type !== 'search-shortcut') return;
  omnisearch.value?.open();
});
</script>

<template>
  <div
    class="tw-flex tw-cursor-pointer tw-items-center tw-px-6 tw-text-primary-900 tw-no-underline"
    @click="omnisearch?.open()"
  >
    <div
      class="tw-rounded-2xl tw-border-solid tw-border-grey-200 tw-bg-white tw-p-1.5 tw-transition-all tw-duration-200 hover:tw-shadow-inner hover:tw-shadow-grey-200/40 lg:tw-w-32 lg:tw-border lg:hover:tw-bg-grey-50"
    >
      <div class="tw-flex tw-items-center tw-justify-center tw-gap-2 tw-text-sm">
        <FontAwesomeIcon icon="far fa-search" />
        <span class="tw-hidden lg:tw-block">Zoeken</span>
      </div>
    </div>
  </div>
  <OmniSearchBar ref="omnisearch" />
</template>
